import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const AtlassianIntelligence = () => {
    const localizedHref = useLocalizedHref(
        "/organization-administration/docs/get-started-with-atlassian-intelligence/"
    );

    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.atlassianIntelligence.title"
                    defaultMessage="Atlassian Intelligence (AI)"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.atlassianIntelligence.content.body"
                    defaultMessage="Get more done with <a>AI-powered summaries</a>, generative AI editing, and natural language to build automations or search issues."
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                data-label-english="Learn more."
                                href={`https://support.atlassian.com${localizedHref}`}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default AtlassianIntelligence;
